export default {
  landingPage: {
    title: {
      zillow: 'Pay Rent Online | Zillow Rent Payments',
      trulia: 'Pay Rent Online | Trulia Rent Payments',
      hotpads: 'Pay Rent Online | HotPads Rent Payments',
    },
    description: {
      zillow: 'Say hello to online rent payments, and goodbye to ' + 'writing checks. Get started on Zillow today.',
      trulia:
        'Say goodbye to checks, and find more ways to pay ' +
        'rent with Trulia. Pay on the go, or set up auto-pay ' +
        'and get more peace of mind.',
      hotpads:
        'Tired of checks? Pay your rent online with HotPads. ' + 'It’s easy, flexible, and secure - get started today!',
    },
  },
  confirmRentDetails: {
    title: {
      zillow: 'Confirm Your Rent Details | Zillow Rent Payments',
      trulia: 'Confirm Your Rent Details | Trulia Rent Payments',
      hotpads: 'Confirm Your Rent Details | HotPads Rent Payments',
    },
  },
  paymentInfoPage: {
    title: {
      zillow: 'Choose Your Payment Method | Zillow Rent Payments',
      trulia: 'Choose Your Payment Method | Trulia Rent Payments',
      hotpads: 'Choose Your Payment Method | HotPads Rent Payments',
    },
  },
  moveInCostsSchedulingPage: {
    title: {
      zillow: 'Schedule Your Move-in Costs | Zillow Rent Payments',
      trulia: 'Schedule Your Move-in Costs | Trulia Rent Payments',
      hotpads: 'Schedule Your Move-in Costs | HotPads Rent Payments',
    },
  },
  paymentSettingsPage: {
    title: {
      zillow: 'Schedule Your Rent | Zillow Rent Payments',
      trulia: 'Schedule Your Rent | Trulia Rent Payments',
      hotpads: 'Schedule Your Rent | HotPads Rent Payments',
    },
  },
  microDepositsPage: {
    title: {
      zillow: 'Verify Your Bank Account | Zillow Rent Payments',
      trulia: 'Verify Your Bank Account | Trulia Rent Payments',
      hotpads: 'Verify Your Bank Account | HotPads Rent Payments',
    },
  },
  dashboardPage: {
    title: {
      zillow: 'Dashboard | Zillow Rent Payments',
      trulia: 'Dashboard | Trulia Rent Payments',
      hotpads: 'Dashboard | HotPads Rent Payments',
    },
  },
  confirmRentAmountChangePage: {
    title: {
      zillow: 'Confirm Rent Amount Change | Zillow Rent Payments',
      trulia: 'Confirm Rent Amount Change | Trulia Rent Payments',
      hotpads: 'Confirm Rent Amount Change | HotPads Rent Payments',
    },
  },
  payOneTimePaymentPage: {
    title: {
      zillow: 'Make a One-Time Payment | Zillow Rent Payments',
      trulia: 'Make a One-Time Payment | Trulia Rent Payments',
      hotpads: 'Make a One-Time Payment | HotPads Rent Payments',
    },
  },
  payPastDueRentPaymentPage: {
    title: {
      zillow: 'Make a Rent Payment | Zillow Rent Payments',
      trulia: 'Make a Rent Payment | Trulia Rent Payments',
      hotpads: 'Make a Rent Payment | HotPads Rent Payments',
    },
  },
};
